var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectSuitcaseCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    stroke: "#FF8027",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 19.6667H31.4366V15.4383C31.4361 14.7918 31.179 14.172 30.7218 13.7148C30.2647 13.2576 29.6448 13.0006 28.9983 13H27C26.3534 13.0006 25.7336 13.2576 25.2764 13.7148C24.8193 14.172 24.5622 14.7918 24.5616 15.4383V19.6667H23C22.5622 19.6666 22.1287 19.7527 21.7242 19.9202C21.3197 20.0876 20.9522 20.3332 20.6427 20.6427C20.3331 20.9523 20.0876 21.3198 19.9201 21.7243C19.7526 22.1287 19.6665 22.5622 19.6666 23V43H21.5416V40.985C21.9948 41.2107 22.4937 41.3299 23 41.3333H33C33.5063 41.3299 34.0051 41.2107 34.4583 40.985V43H36.3333V23C36.3334 22.5622 36.2473 22.1287 36.0798 21.7243C35.9123 21.3198 35.6668 20.9523 35.3573 20.6427C35.0477 20.3332 34.6802 20.0876 34.2757 19.9202C33.8712 19.7527 33.4377 19.6666 33 19.6667ZM26.4366 15.4383C26.4365 15.3643 26.451 15.291 26.4793 15.2227C26.5076 15.1543 26.5491 15.0921 26.6014 15.0398C26.6537 14.9875 26.7159 14.946 26.7843 14.9177C26.8527 14.8894 26.926 14.8749 27 14.875H29C29.074 14.8749 29.1473 14.8894 29.2156 14.9177C29.284 14.946 29.3462 14.9875 29.3985 15.0398C29.4508 15.0921 29.4923 15.1543 29.5206 15.2227C29.5489 15.291 29.5634 15.3643 29.5633 15.4383V19.6667H26.4366V15.4383ZM33 39.4583H23C22.6134 39.4576 22.2429 39.3038 21.9695 39.0304C21.6962 38.7571 21.5423 38.3866 21.5416 38V23C21.5423 22.6135 21.6962 22.2429 21.9695 21.9696C22.2429 21.6963 22.6134 21.5424 23 21.5417H24.5633V28.1667H26.4383V21.5417H29.5633V28.1667H31.4383V21.5417H33C33.3865 21.5424 33.757 21.6963 34.0304 21.9696C34.3037 22.2429 34.4576 22.6135 34.4583 23V38C34.4576 38.3866 34.3037 38.7571 34.0304 39.0304C33.757 39.3038 33.3865 39.4576 33 39.4583Z",
    fill: "#FF8027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectSuitcaseCritical);
export default __webpack_public_path__ + "static/media/object-suitcase-critical.1c727e7465537a4e20fe455ff2b58585.svg";
export { ForwardRef as ReactComponent };